/* This FaqTemplate requires Tailwind CSS v2.0+ */
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/outline';
import useLocale from 'next-translate/useTranslation';

import clsxm from '@/lib/clsxm';

import MarkdownBlock from './Chat/MarkdownBlock';

const faqs = [
  {
    question: 'Do I need prior experience with AI to attend this workshop?',
    answer:
      'No, prior experience with AI is not required. The workshop will cover foundational concepts and provide hands-on experience with generative AI, making it suitable for participants at all levels of familiarity with AI technology.',
  },
  {
    question: 'What will I learn in this AI workshop?',
    answer:
      'Marky Chat, 300+ Templates, Image Generator with Upscale, Image to Video, Professional Headshots, Video Transcription, Long Text Handling, Voice Cloning, Extensive Libraries and more.',
  },
  {
    question: 'What do I need to bring to the workshop?',
    answer:
      'You should bring a laptop to participate in the interactive and hands-on portions of the workshop. Access to the internet will be provided.',
  },
  {
    question: 'Can I request this workshop for my team?',
    answer:
      "Yes, you can request this workshop for your team. It's a great opportunity to empower your team to create viral content, streamline workflows, and turn ideas into revenue using generative AI tools like Easy-Peasy.AI. Please contact us via the form below.",
  },
];

export default function FaqTranscription() {
  const { t, lang } = useLocale('common');

  if (lang !== 'en') return null;

  return (
    <div className='bg-gray-50 dark:bg-slate-900'>
      <div className='mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8'>
        <div className='mx-auto max-w-3xl divide-y-2 divide-gray-200 dark:divide-slate-600'>
          <h2 className='text-center text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Frequently asked questions')}
          </h2>
          <dl className='mt-6 space-y-6 divide-y divide-gray-200 dark:divide-slate-600'>
            {faqs.map((faq) => (
              <Disclosure as='div' key={faq.question} className='pt-6'>
                {({ open }) => (
                  <>
                    <dt className='text-lg'>
                      <Disclosure.Button className='flex w-full items-start justify-between text-left text-gray-400 dark:text-slate-400'>
                        <span className='font-medium text-gray-900 dark:text-slate-200'>
                          {faq.question}
                        </span>
                        <span className='ml-6 flex h-7 items-center'>
                          <ChevronDownIcon
                            className={clsxm(
                              open ? '-rotate-180' : 'rotate-0',
                              'h-6 w-6 transform'
                            )}
                            aria-hidden='true'
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as='dd' className='mt-2 pr-12'>
                      <div className='text-base text-gray-500 dark:text-slate-400'>
                        <MarkdownBlock
                          message={faq.answer.replace(/\n/g, '  \n')}
                        />
                      </div>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
